import React from 'react';

// Self-contained admin editor for a worker's weekly availability (PartnerAvailability). Loads + saves
// via the web /graphql directly (independent of the profile redux-form + its Update button). One slot
// per day: checked = available in [start,end]; unchecked = no restriction that day ("available anytime").
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function gql(query, variables) {
  return fetch('/graphql', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
    body: JSON.stringify({ query, variables }),
  }).then(r => r.json());
}

class WorkerScheduleEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true, busy: false, msg: null,
      days: DAYS.map((_, i) => ({ dayOfWeek: i, on: false, startTime: '09:00', endTime: '17:00' })),
    };
  }

  componentDidMount() {
    const { userId } = this.props;
    if (!userId) { this.setState({ loading: false }); return; }
    gql(`query($u:String){ getPartnerAvailabilityByUser(userId:$u){ status results{ dayOfWeek startTime endTime isActive } } }`, { u: userId })
      .then(j => {
        const rows = (j && j.data && j.data.getPartnerAvailabilityByUser && j.data.getPartnerAvailabilityByUser.results) || [];
        const byDay = {};
        rows.forEach(r => { byDay[r.dayOfWeek] = r; });
        this.setState({
          loading: false,
          days: DAYS.map((_, i) => byDay[i]
            ? { dayOfWeek: i, on: byDay[i].isActive !== false, startTime: byDay[i].startTime || '09:00', endTime: byDay[i].endTime || '17:00' }
            : { dayOfWeek: i, on: false, startTime: '09:00', endTime: '17:00' }),
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  upd(i, patch) {
    this.setState(s => ({ days: s.days.map((x, idx) => idx === i ? { ...x, ...patch } : x) }));
  }

  save = async () => {
    const { userId } = this.props;
    this.setState({ busy: true, msg: null });
    const data = this.state.days.filter(d => d.on && d.startTime && d.endTime)
      .map(d => ({ dayOfWeek: d.dayOfWeek, startTime: d.startTime, endTime: d.endTime, isActive: true }));
    const j = await gql(`mutation($u:String,$d:String){ setPartnerAvailabilityByUser(userId:$u,data:$d){ status errorMessage } }`, { u: userId, d: JSON.stringify(data) });
    const r = j && j.data && j.data.setPartnerAvailabilityByUser;
    this.setState({ busy: false, msg: r && r.status === 200 ? 'Schedule saved ✅' : ((r && r.errorMessage) || 'Could not save schedule.') });
  };

  render() {
    const { loading, busy, msg, days } = this.state;
    const box = { border: '1px solid #eee', borderRadius: 10, padding: '16px 18px', marginTop: 22 };
    if (loading) return <div style={box}>Loading schedule…</div>;
    return (
      <div style={box}>
        <div style={{ fontWeight: 'bold', marginBottom: 4, fontSize: 16 }}>Weekly availability</div>
        <div style={{ fontSize: 13, color: '#777', marginBottom: 14 }}>Unchecked day = available anytime that day. Check a day to limit it to a time window.</div>
        {days.map((d, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 9 }}>
            <label style={{ width: 130, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
              <input type="checkbox" checked={d.on} onChange={e => this.upd(i, { on: e.target.checked })} /> {DAYS[i]}
            </label>
            <input type="time" value={d.startTime} disabled={!d.on} onChange={e => this.upd(i, { startTime: e.target.value })} style={{ padding: '5px 8px', border: '1px solid #ddd', borderRadius: 6 }} />
            <span style={{ color: '#888' }}>to</span>
            <input type="time" value={d.endTime} disabled={!d.on} onChange={e => this.upd(i, { endTime: e.target.value })} style={{ padding: '5px 8px', border: '1px solid #ddd', borderRadius: 6 }} />
          </div>
        ))}
        <button type="button" onClick={this.save} disabled={busy} style={{ marginTop: 12, background: '#e11900', color: '#fff', border: 0, borderRadius: 8, padding: '10px 20px', fontWeight: 'bold', cursor: 'pointer' }}>
          {busy ? 'Saving…' : 'Save schedule'}
        </button>
        {msg ? <span style={{ marginLeft: 14, fontSize: 14 }}>{msg}</span> : null}
      </div>
    );
  }
}

export default WorkerScheduleEditor;
